import { render, staticRenderFns } from "./EduExerciseRecord.vue?vue&type=template&id=3e78925e&scoped=true&"
import script from "./EduExerciseRecord.vue?vue&type=script&lang=js&"
export * from "./EduExerciseRecord.vue?vue&type=script&lang=js&"
import style0 from "./EduExerciseRecord.vue?vue&type=style&index=0&id=3e78925e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e78925e",
  null
  
)

export default component.exports